<div class="container">
  @if (initialized) {
    @if (!internalTests.length) {
      <div class="mat-body-strong">
        This project has no onsite tests.
      </div>
    }
    @for (internalTest of internalTests; track internalTest) {
      <div>
        <mat-checkbox
          [checked]="internalTest.checked"
          (change)="onChange(internalTest, $event.checked)">
          <div class="mat-body-strong">
            {{internalTest.name}}
            @if (internalTest.record_by_station) {
              <span class="mat-caption">(by station)</span>
            }
          </div>
        </mat-checkbox>
      </div>
    }
  }

</div>

